<template>
  <div id="alert-bar">
    <transition-group name="slide-down" appear>
      <notice v-for="(alert, index) in alerts"
        :key="index"
        :class="alert.theme"
        :closable="true"
        @close="close(alert.text)">
        <div v-html="alert.text"/>
      </notice>
    </transition-group>
  </div>
</template>

<script>
import { actions, getters } from '../../utils'

export default {
  computed: getters('alerts'),
  methods: {
    close(text) {
      this.CLOSE_ALERT({ text })
    },
    ...actions('CLOSE_ALERT'),
  },
}
</script>

<style lang="scss">
@import '~style/variables';

#alert-bar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  z-index: 85;
  .notice {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/AlertBar.vue